// Keyed on the feed's party.abbr. `className` is the party name the styles
// use (bar-dem, party-gop, .np...), so the SCSS didn't have to change.
// Use partyClass(choice) from race-helpers.js rather than reading this directly.
export default {
  R: {
    abbr: 'R',
    label: 'Republican',
    className: 'gop',
  },
  D: {
    abbr: 'D',
    label: 'Democrat',
    className: 'dem',
  },
  L: {
    abbr: 'L',
    label: 'Libertarian',
    className: 'lib',
  },
  G: {
    abbr: 'G',
    label: 'Green',
    className: 'grn',
  },
  NP: {
    abbr: 'NP',
    label: 'No party',
    className: 'np',
  },
  AI: {
    abbr: 'AI',
    label: 'American Independent',
    className: 'aip',
  },
  PF: {
    abbr: 'PF',
    label: 'Peace and Freedom',
    className: 'pfp',
  },
} as Record<string, { abbr: string; label: string; className: string }>;
